import { Normal4 } from 'components/Typography';
import React from 'react';
import { EcoSystemCard } from './EcoSystemCard';
import { ecosystemData } from 'utils/constants/ecosystem-data';

export const EcosystemDapp = () => {
  return (
    <>
      {Object.entries(ecosystemData).map(([key, value]) => (
        <div className='pt-10' key={key}>
          <Normal4>{key}</Normal4>
          <div className='mt-4'>
            <div className='flex flex-col gap-4'>
              <div className='grid grid-cols-1 gap-3 lg:grid-cols-4'>
                <EcoSystemCard cardData={value} title={key} />
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};
